import {Card} from 'platform/components';

import {useCallback} from 'react';

import {mergeAll} from 'ramda';

import i18n from '@dms/i18n';
import {testIds} from '@dms/routes';
import {DmsDataGrid, Section, SectionTab} from '@dms/shared';

import type {EagGridMaximization, QueryFilterObject} from 'features/eag-grid';

import {useWorkshopUrl} from '../../../../hooks/useWorkshopUrl';

interface ActivityLogsProps {
  maximization?: EagGridMaximization;
}

export function ActivityLogs(props: ActivityLogsProps) {
  const {serviceCaseId} = useWorkshopUrl();

  const queryModifier = useCallback(
    (filter: QueryFilterObject) => mergeAll([filter, {serviceCaseId}]),
    [serviceCaseId]
  );

  const tabs: SectionTab[] = [
    {
      content: (
        <Card
          title={i18n.t('general.labels.activityLogs')}
          isFullHeight
          key="activity-logs-datagrid"
        >
          <DmsDataGrid
            maximization={props.maximization}
            gridCode="activity-log-service-case"
            queryModifier={queryModifier}
            data-testid={testIds.workshop.serviceCaseDetail('activityLogs')}
          />
        </Card>
      ),
      queryId: 'activityLogs',
      title: i18n.t('general.labels.activityLogs'),
    },
  ];

  return <Section tabs={tabs} isFullHeight />;
}
